import { Capacitor, registerPlugin } from "@capacitor/core";
import { App } from "@capacitor/app";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

export const isNative = () => Capacitor.isNativePlatform();
export const keyStore = () => (isNative() ? localStorage : sessionStorage);

export async function saveFile(blobUrl, name) {
  if (!isNative()) {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = name;
    a.click();
    return;
  }
  const blob = await (await fetch(blobUrl)).blob();
  const data = await new Promise((res) => {
    const r = new FileReader();
    r.onload = () => res(String(r.result).split(",")[1]);
    r.readAsDataURL(blob);
  });
  const { uri } = await Filesystem.writeFile({ path: name.replace(/[/\\]/g, "_"), data, directory: Directory.Cache });
  await Share.share({ title: name, files: [uri] });
}

export function onBackButton(handler) {
  if (!isNative()) return () => {};
  const sub = App.addListener("backButton", handler);
  return () => sub.then((s) => s.remove());
}

export const exitApp = () => App.exitApp();

const Privacy = registerPlugin("Privacy");

export const setSecureScreen = (on) => (isNative() ? Privacy.setSecure({ on }).catch(() => {}) : Promise.resolve());

export function onScreenshot(handler) {
  window.addEventListener("aphscreenshot", handler);
  return () => window.removeEventListener("aphscreenshot", handler);
}
